import { Box } from '@mui/material';
import { useGetAllPatientChallengesByID } from '_api';
import { AddToPatientProfileHeader } from 'components/molecules';
import { CreateSelectMultipleField } from 'components/molecules/formFields';
import { AddChallengeToPatientForm } from 'components/organisms/forms';
import { noop } from 'lodash';
import React from 'react';
import { useChallenges } from 'utils/hooks';

import { FormBuilder } from './form-builder';
import { AddChallengeToPatientProfileFormProps } from './types';

export const AddChallengeToPatientProfileForm = ({
  onSubmit,
  updateListOfObjects,
  updateObject,
  challengeList,
  patientId,
}: AddChallengeToPatientProfileFormProps) => {
  const {
    challengeOptions,
    allChallenges,
    isLoading: isLoadingChallenges,
  } = useChallenges();
  const isFetched = !isLoadingChallenges;
  const { data: patientChallenges } = useGetAllPatientChallengesByID(patientId);

  const updateChallengeList = async (key: any, arg: any) => {
    updateListOfObjects(arg);
  };

  const updateChallengeEntry = async (key: any, arg: any, contentId: number) => {
    updateObject(key, arg, contentId);
  };

  const filteredChallengeOptions = () => {
    if (patientChallenges) {
      return challengeOptions.filter(
        (option) =>
          !patientChallenges.some(
            (patientChallenge) => patientChallenge.content.id === Number(option.name),
          ),
      );
    }
    return [];
  };

  const getChallengeImageAndTitle = (id: number) => {
    let challenge = null;
    if (!isLoadingChallenges && allChallenges) {
      challenge = allChallenges.find((ch) => ch.id === id) || null;
    }
    if (challenge)
      return (
        <AddToPatientProfileHeader
          title={challenge.title}
          imageUrl={challenge.fullImageUrl}
        />
      );
    return null;
  };

  const getChallengeTargetSide = (id: number) => {
    if (!isLoadingChallenges && allChallenges) {
      const challenge = allChallenges.find((ch) => ch.id === id);
      return typeof challenge?.targetSide === 'string'
        ? challenge.targetSide
        : challenge?.targetSide?.name ?? 'NA';
    }
    return 'NA';
  };

  const challengeFormFields = [
    {
      component: CreateSelectMultipleField,
      fieldKey: 'contentId',
      label: `Select Challenge`,
      options: filteredChallengeOptions() || [],
      required: true,
      xs: 12,
      onAddOption: noop,
      readonly: true,
    },
  ];

  return isFetched ? (
    <Box style={{ maxHeight: '900px' }}>
      <FormBuilder
        formFields={challengeFormFields}
        onSubmit={onSubmit}
        onUpdate={updateChallengeList}
        hideSubmit={true}
      />
      {challengeList.length > 0 &&
        challengeList.map((challenge) => (
          <Box key={challenge.contentId} sx={{ marginBottom: '20px' }}>
            {getChallengeImageAndTitle(challenge.contentId)}
            <AddChallengeToPatientForm
              initValue={challenge}
              onUpdate={(key: any, arg: any) =>
                updateChallengeEntry(key, arg, challenge.contentId)
              }
              onSubmit={() => {}}
              hidePatientSelect={true}
              hideSubmit={true}
              contentTargetSide={getChallengeTargetSide(challenge.contentId)}
            />
            <br />
          </Box>
        ))}
    </Box>
  ) : null;
};
